var defaultStyles = {
  "root_button": "Base-InputNumber--RootButton",
  "number_input": "Base-InputNumber--NumberInput",
  "after": "Base-InputNumber--After",
  "step_layer": "Base-InputNumber--StepLayer",
  "root": "Base-InputNumber",
  "suffix": "Base-InputNumber--Suffix",
  "button": "Base-InputNumber--Button",
  "button_embed": "Base-InputNumber--ButtonEmbed",
  "button_xs": "Base-InputNumber--ButtonXs",
  "button_sm": "Base-InputNumber--ButtonSm",
  "button_md": "Base-InputNumber--ButtonMd",
  "button_lg": "Base-InputNumber--ButtonLg",
  "plus": "Base-InputNumber--Plus",
  "minus": "Base-InputNumber--Minus"
};

export { defaultStyles as default };
